import "core-js/stable";
import "regenerator-runtime/runtime";
// CSS vendor
import "./styles.css";
import "vue-select/dist/vue-select.css";

// JS vendor
import $ from "jquery";
import Rollbar from "lib/rollbar";
import bloggerPages from "blogger/pages/index";

// load stimulus controllers
import "controllers/blogger";

window.Rollbar = Rollbar;

$(document).ready(() => {
  bloggerPages();
});
